import { createTheme } from "@mui/material/styles";

export const PRIMARY = "#662d91";

export const muiTheme = (direction = "ltr") =>
  createTheme({
    direction: direction,
    palette: {
      primary: {
        main: PRIMARY,
      },
    },
    typography: {
      fontFamily: ["Poppins", "sans-serif"].join(","),
    },
    components: {
      MuiOutlinedInput: {
        styleOverrides: {
          root: {
            borderRadius: "28px",
          },
        },
      },
      MuiTextField: {
        styleOverrides: {
          root: {
            margin: 0,
            "& .MuiFormHelperText-root": {
              textAlign: "start",
            },
          },
        },
      },
      MuiButton: {
        styleOverrides: {
          root: {
            fontSize: "16px",
            lineHeight: "20px",
            letterSpacing: "0%",
            padding: "13px 24px 11px",
            borderRadius: "24px",
          },
        },
      },
      MuiDialog: {
        styleOverrides: {
          paper: {
            borderRadius: "26px",
          },
        },
      },
    },
  });

export const GLOBAL_STYLES = (theme) => ({
  ".content": {
    padding: "44px",
    [theme.breakpoints.down("md")]: {
      padding: "24px",
    },
  },
  ".form__label": {
    color: "#333333",
    fontWeight: "500",
    fontSize: "15px",
    lineHeight: "24px",
    marginBottom: "8px",
    display: "inline-block",
  },
});

export default muiTheme;
